// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// // import FileUpload from "../../components/common/FileUpload";
// import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
// import Loader from "../../components/common/Loader";
// // import Badge from '@mui/material/Badge';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMagnifyingGlass, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
// import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
// import SecCard from "../../components/common/SecCard";
// import { Row, Col } from "react-bootstrap";
// // import { green, yellow, red, deepPurple } from '@mui/material/colors';
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import HeaderCard from "../../components/common/HeaderCard";
// import BackButton from "../../components/common/BackButton";

// import css from "../../css/admin/users-page.module.css";


// const AllStates = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [limit, setLimit] = useState(0);
//   const [allInstitutes, setAllInstitutes] = useState([]);
//   const [page, setPage] = useState(1);
//   const [sortType, setSortType] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   // const [mouStatus, setMouStatus] = useState("");
//   const [totalPages, setTotalPages] = useState(0);
//   // const [rerender, setRerender] = useState(true);
//   const navigate = useNavigate();

//   const isReadOnly = hasReadOnlyAccess();
//   useEffect(() => {
//     async function getAllChapters() {
//       setIsLoading(true);

//       try {
//         // const adminId = process.env.REACT_APP_ADMIN_ID;
//         // const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
//         // const basicAuth = btoa(`${adminId}:${adminPassword}`);
//         const response = await fetch(
//           `${SERVER_ORIGIN}/api/state/get-all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
//           }`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               //Authorization: `Basic ${basicAuth}`, // Include Basic Authentication
//               "auth-token": sessionStorage.getItem("token"),
//             },
//           }
//         );

//         const result = await response.json();
//         // console.log(result)
//         setIsLoading(false);
//         if (response.status >= 400 && response.status < 600) {
//           if (response.status === 401) {
//             navigate("/admin/login");
//           } else if (response.status === 500) {
//             toast.error(result.statusText);
//           }
//         } else if (response.status === 200) {
//           setAllInstitutes(result.filteredRegions);
//           setTotalPages(result.totalPages);
//         } else {
//           // for future
//         }
//       } catch (err) {
//         setIsLoading(false);
//       }
//     }

//     getAllChapters();
//   }, [page, sortType, searchQuery, navigate, limit]);
//   const handelChapterRemove = async (_id) => {
//     try {
//       const response = await fetch(`${SERVER_ORIGIN}/api/chapter/auth/dlt/${_id}`, {
//         method: 'POST',
//         headers: {
//           'auth-token': sessionStorage.getItem('token'),
//           'Content-Type': 'application/json',
//         },
//       });
//       const result = await response.json();
//       if (response.status >= 300) {
//         toast.error(result.statusText);
//       } else {
//         toast.success(result.statusText);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     } finally {
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     }
//   }
//   const rows = allInstitutes.map((institute, idx) => ({ ...institute, 'id': idx + 1 }))
//   // let rowIndexCounter = 0;
//   const columns = [
//     {
//       field: 'id',
//       headerName: 'ID',
//       width: 300,
//     },
//     {
//       field: 'name',
//       headerName: 'State Name',
//       width: 800,
//       editable: true,
//     },
//     // {
//     //     headerName: 'Remove',
//     //     align: 'center',
//     //     type: 'button',
//     //     width: 80,
//     //     renderCell: (params) => {
//     //         const { row: { _id } } = params;
//     //         const handleRemoveClick = () => {
//     //             handelChapterRemove(_id);
//     //         };
//     //         return (
//     //             <div onClick={handleRemoveClick}>
//     //                 <FontAwesomeIcon icon={faTrash} style={{ color: "red", marginRight: "5px", cursor: "pointer" }} />
//     //             </div>
//     //         );
//     //     }
//     // }
//   ];

//   function CustomColumnMenu(props) {
//     return (
//       <GridColumnMenu
//         {...props}
//         slots={{
//           // Add item
//           // columnMenuUserItem: CustomUserItem,
//         }}
//         slotProps={{
//           columnMenuUserItem: {
//             // set `displayOrder` for new item
//             displayOrder: 15,
//             // pass additional props
//             myCustomValue: 'Do custom action',
//             myCustomHandler: () => alert('Custom handler fired'),
//           },
//         }}
//       />
//     );
//   }
//   return (
//     <div className={css.outerDiv}>
//       {/* <HeaderCard>
//                 <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
//                 <h1 className="headerTitle">Regions</h1>
//                 <hr />
//                 <p className="headerSubtitle">
//                     You can view the region list.
//                 </p>
//                 <p className="headerSubtitle">
//                     Note: No change can be done here.
//                 </p>
//             </HeaderCard> */}

//       <div className={css.headerSection}>
//         <div className={css.headerLeft}>
//           <BackButton
//             text="Back to Dashboard"
//             customPath={getDashboardPath()}
//           />
//         </div>
//       </div>
//       {hasReadOnlyAccess() && (
//         <div className={css.readOnlyAlert}>
//           <div className="alert alert-info" role="alert">
//             <strong>Read-Only Access:</strong> You can view all Terms and
//             conditions data but cannot add, edit, or delete any records.
//           </div>
//         </div>
//       )}
//       {/* <div className="my-4">
//         <SecCard>
//           <Row className="g-4">
//             <div
//               className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
//             >
//               <div className={css.serviceName}>States</div>
//             </div>
//             <div className={css.headerRight}>
//               {!isReadOnly && (
//                 <button
//                   className={css.addBtn}
//                   onClick={() =>
//                     navigate(`/states/insert`)
//                   }
//                 >
//                   <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
//                   Add State
//                 </button>
//               )}
//             </div>
//           </Row>
//         </SecCard>
//       </div> */}
//       <div className="my-4">
//         <SecCard>
//           <Row className="g-4">
//             <div
//               className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
//             >
//               <div className={css.serviceName}>States Data</div>

//               <div className={css.headerRight}>
//                 {!isReadOnly && (
//                   <div className={css.actionButtons}>
//                     <button className={css.addBtn} onClick={() =>
//                       navigate(`/states/insert`)
//                     }>
//                       <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
//                       Add State
//                     </button>

//                     {/* <ActionsDropdown /> */}
//                   </div>
//                 )}
//               </div>
//             </div>

//           </Row>
//         </SecCard>
//       </div>

//       <div className={css.filterBtns}>
//         <div className={css.searchInputs}>
//           <div
//             className="d-flex"
//             style={{
//               position: "relative",
//               justifyContent: "end",
//               alignItems: "center",
//             }}
//           >
//             <input
//               type="text"
//               value={searchQuery}
//               placeholder="Search from state list"
//               onChange={(e) => {
//                 setSearchQuery(e.target.value);
//                 // setPage(1);
//               }}
//               className={css.searchInput}
//             />
//             <FontAwesomeIcon
//               icon={faMagnifyingGlass}
//               style={{ color: "black", position: "absolute", right: "10px" }}
//             />
//           </div>
//         </div>
//       </div>
//       {isLoading ? (
//         <Loader />
//       ) : (
//         <div>
//           <DataGrid
//             slotProps={{
//               loadingOverlay: {
//                 variant: "skeleton",
//                 noRowsVariant: "skeleton",
//               },
//             }}
//             rows={rows}
//             columns={columns}
//             initialState={{
//               pagination: {
//                 paginationModel: { pageSize: 7, page: 0 },
//               },
//             }}
//             slots={{ columnMenu: CustomColumnMenu }}
//           // checkboxSelection
//           // disableRowSelectionOnClick
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default AllStates;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColumnMenu } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { State } from "country-state-city"; // 🧭 Import from library

 import css from "../../css/admin/users-page.module.css";
 import Loader from "../../components/common/Loader";
import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
import SecCard from "../../components/common/SecCard";
import BackButton from "../../components/common/BackButton";


const AllStates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const isReadOnly = hasReadOnlyAccess();

  useEffect(() => {
    async function getAllStates() {
      try {
        setIsLoading(true);

        // 🧭 Get states of India (or change the country code if needed)
        const states = State.getStatesOfCountry("IN");

        console.log("Fetched States:", states);

        // Filter and sort states
        const formattedStates = states.map((state, idx) => ({
          id: idx + 1,
          name: state.name,
          isoCode: state.isoCode,
          countryCode: state.countryCode,
        }));
        console.log("Formatted States:", formattedStates);

        setAllStates(formattedStates);
      } catch (error) {
        toast.error("Failed to load states");
      } finally {
        setIsLoading(false);
      }
    }

    getAllStates();
  }, []);

  // 🧮 Search filter
  const filteredStates = allStates.filter((state) =>
    state.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "State Name", width: 400 },
    { field: "isoCode", headerName: "ISO Code", width: 150 },
    { field: "countryCode", headerName: "Country Code", width: 150 },
  ];

  function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        slotProps={{
          columnMenuUserItem: {
            displayOrder: 15,
            myCustomValue: "Do custom action",
            myCustomHandler: () => alert("Custom handler fired"),
          },
        }}
      />
    );
  }

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view state data but cannot
            add, edit, or delete any records.
          </div>
        </div>
      )}

      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>States Data</div>
              <div className={css.headerRight}>
                {/* {!isReadOnly && (
                  <div className={css.actionButtons}>
                    <button
                      className={css.addBtn}
                      onClick={() => navigate(`/states/insert`)}
                    >
                      <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                      Add State
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </Row>
        </SecCard>
      </div>

      <div className={css.filterBtns}>
        <div className={css.searchInputs}>
          <div
            className="d-flex"
            style={{
              position: "relative",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={searchQuery}
              placeholder="Search from state list"
              onChange={(e) => setSearchQuery(e.target.value)}
              className={css.searchInput}
            />
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              style={{ color: "black", position: "absolute", right: "10px" }}
            />
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <DataGrid
            rows={filteredStates}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            slots={{ columnMenu: CustomColumnMenu }}
          />
        </div>
      )}
    </div>
  );
};

export default AllStates;

